module.exports = __webpack_public_path__ + "img/112.1.43736931.jpg";